var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLiteMooc05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3414 34.4972V16.1953C39.3414 15.3904 38.6825 14.7319 37.8779 14.7319H8.46341C7.65883 14.7319 7 15.3908 7 16.1953V42.5366C7 43.341 7.65853 44 8.46341 44H28.5891",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9754 17.6586H19.7363L16.7743 20.5854H7.36578",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7802 17.6587H15.7808",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8532 17.6587H12.8539",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92633 17.6587H9.92696",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6585 27.7319L23.9999 31.3309C23.9999 36.8385 24.9362 42.1475 31.317 43.8293C37.6977 42.1475 38.634 36.8385 38.634 31.3309L34.9755 27.7319H27.6585Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8908 30.6586L26.9917 32.5268C27.0539 34.5606 27.3254 36.889 28.3645 38.5204C29.0832 39.6489 30.1054 40.332 31.3169 40.7651C32.5285 40.332 33.5507 39.6489 34.2694 38.5204C35.3084 36.889 35.58 34.5606 35.6422 32.5268L33.743 30.6586H28.8908Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6585 24.2439H21.3414",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3414 27.4637H10.6585V33.9026H21.3414V27.4637Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6585 37.1221H21.3414",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6585 40.3416H21.3414",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLiteMooc05);
export default __webpack_public_path__ + "static/media/vLite-MOOC05.6f9ed7ea762b1a1f17f680da8fe25f38.svg";
export { ForwardRef as ReactComponent };